import { alpha } from "@mui/material";

const styles = (theme) => ({
  boxHeader: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  containerStackedBarChart: { width: "100%", maxWidth: "600px" },
  boxBody: {
    width: "100%",
    display: "flex",
    gap: 1,
    height: "700px",
    p: 1,
  },
  buttonRefresh: {
    color: theme.palette.text.textContrast,
    borderColor: theme.palette.text.main,
    minWidth: "40px",
    padding: "10px",
    lineHeight: 1,
    "& .rotating": {
      animation: "spin 1s linear infinite",
    },
    "@keyframes spin": {
      "0%": {
        transform: "rotate(0deg)",
      },
      "100%": {
        transform: "rotate(-360deg)",
      },
    },
  },
  buttonSearch: {
    color: theme.palette.text.textContrast,
    borderColor: theme.palette.text.main,
    minWidth: "40px",
    padding: "10px",
    lineHeight: 1,
  },
  buttonSearchModal: {
    minWidth: "40px",
    padding: "10px",
    lineHeight: 1,
  },
  modalSearch: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    borderRadius: "16px",

    width: " 90%",
    maxWidth: "500px",
    height: "400px",
    maxHeight: "90vh",
    overflow: "hidden",
  },
  containerBoxClearSearch: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
  },
  boxNoTickets: {
    height: "60%",
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  containerSearch: { display: "flex", alignItems: "center", gap: 1, p: 2 },
  search: {
    width: "100%",
    maxWidth: 500,
    display: "flex",
    flexGrow: 1,
    fontSize: "0.90rem", // diminui fonte geral

    "@media (max-width: 1643px)": {
      width: "100%",
    },
  },
  containerTextNoTickets: {
    position: "absolute",
    left: "75%",
    top: "30%",
    transform: "translateX(-50%)",
    "@media (max-width: 700px)": {
      top: "15%",
    },
    "@media (max-width: 600px)": {
      left: "40%",
      top: "12%",
    },
    "@media (max-width: 430px)": {
      left: "40%",
      top: "10%",
    },
  },
  containerImgNoTickets: {
    position: "absolute",
    left: "50%",
    transform: "translateX(-40%)",
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },
  paperFluxo: {
    borderRadius: "16px",
    flex: 1,
    height: "100%",
    overflowY: "auto",
    position: "relative",
    p: 1,
  },
  containerStatusMensagem: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 0.5,
  },
  paperFluxoTickets: {
    borderRadius: "16px",
    flex: 1,
    height: "100%",
    overflowY: "auto",
    position: "relative",
  },
  ticketNoFind: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
  },
  containerCheckBox: {
    position: "relative",
    borderRadius: "16px",
    overflow: "hidden",
    transition: "0.2s",
  },
  checkBox: {
    position: "absolute",
    top: 4,
    right: 4,
    zIndex: 2,
    backgroundColor:
      theme.palette.mode === "dark"
        ? theme.palette.colors.black.medium
        : theme.palette.colors.black.light,
    borderRadius: "4px",
    "&:hover": {
      backgroundColor:
        theme.palette.mode === "dark"
          ? theme.palette.colors.black.light
          : theme.palette.colors.black.lighter,
    },
  },
  checkOverlay: {
    position: "absolute",
    pointerEvents: "none",
    inset: 0,
    zIndex: 1,
    transition: "0.2s",
  },
  modal: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    borderRadius: "16px",
    p: 4,
    width: " 90%",
    maxWidth: "1000px",
    height: "700px",
    maxHeight: "90vh",
    overflow: "auto",
  },
  titleDataProtocoloModal: {
    fontWeight: "bold",
    fontSize: "14px",
    color: theme.palette.primary.main,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "100%",
  },
  titleDataClienteModal: {
    fontWeight: "bold",
    fontSize: "14px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "100%",
  },
  boxData: { display: "flex", gap: 1, alignItems: "center" },
  titleDataModal: {
    fontWeight: "bold",
    fontSize: "14px",
  },
  containerSendMensagem: {
    mt: "auto",
    pt: 2,
    display: "flex",
    flexDirection: "column",
  },
  containerActionsMensagens: {
    display: "flex",
    justifyContent: "flex-end",
    mt: 2,
    gap: 1,
  },
  containerStatusModal: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 0.5,
  },
  titleModal: {
    fontWeight: "bold",
    fontSize: "20px",
    mb: 2,
  },
  paperAllTickets: {
    display: "flex",
    flexDirection: "column",
    gap: 1,
    height: "400px",
    overflow: "auto",
    p: 2,
    borderRadius: "16px",
  },
  paperTickets: {
    width: "100%",
    borderRadius: "16px",
    p: 2,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 1,
    backgroundColor: theme.palette.background.default,
  },
  containerModal: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
    justifyContent: "space-between",
    height: "100%",
  },
  chipStatus: {
    minWidth: "120px",
    color: theme.palette.white.main,
  },
  titleChipModal: {
    fontWeight: "bold",
    fontSize: "10px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  },
  containerButton: {
    mb: 2,

    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    position: "sticky",
    top: 0,
    zIndex: 10,
    backgroundColor: alpha(theme.palette.background.paper, 0.8),
    backdropFilter: "blur(6px)",

    minHeight: "80px",
  },
  boxActions: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    height: "80px",
    p: 2,
  },
  containerCloseDrawer: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
  },
  containerActions: { display: "flex", alignItems: "center" },
});
export default styles;
